import { createAsyncThunk } from '@reduxjs/toolkit';
import { controlPanelListService } from './ControlPanelList.service';
import { errorHandlerThunk } from '../../App/App.thunk';

export const getControlPanelListThunk = createAsyncThunk(
  `controlPanel/getControlPanelListThunk`,
  async (_, thunkAPI) => {
    try {
      const response = await controlPanelListService.getList();

      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
